import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';

import TemplateFeed from './TemplateFeed';
import { TemplateFeedStrapiComponent } from './types';

export class TemplateFeedComponentBuilder extends ComponentBuilder {
  public key = 'list.template-feed' as const;

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const fieldName = this.getFieldNameSymbol(inputs.componentData);

    const page = await inputs.fetchManager.addRequestOptionsAndWaitForResponse<{
      fieldName: TemplateFeedStrapiComponent;
    }>({
      populate: {
        [fieldName]: {
          populate: {
            templates: true,
          },
        },
      },
    });

    const componentData = page[fieldName];
    if (!componentData) {
      return undefined;
    }

    return {
      title: componentData.title,
      description: componentData.description,
      templates: componentData.templates
        ?.filter((templateIdHolder) => !!templateIdHolder)
        .map((templateIdHolder) => templateIdHolder.templateId),
      moreButtonLink: '/designs/all',
    };
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs) {
      return <TemplateFeed {...inputs} />;
    } else {
      return null;
    }
  }
}
